import { fetchApi } from './api';
import { getCurrentUserEmail } from './auth';

let sessionAccess = [];
let userRole = '';
let userDivision = '';
let isSupplier = false;
let loaded = false;
let fetchedSuccessfully = false;
let onLoadedCallbacks = [];

export function onAccessLoaded(cb) {
  if (loaded) { cb(); return; }
  onLoadedCallbacks.push(cb);
}

export async function fetchUserAccess() {
  isSupplier = sessionStorage.getItem('user_type') === 'supplier';
  const email = getCurrentUserEmail();
  if (!email) return;
  if (fetchedSuccessfully) return;
  try {
    const res = await fetchApi('/api/UserMaster/GetUserDetailsByEmail', {
      method: 'POST',
      body: JSON.stringify({ EmailID: email }),
      skipLoader: true
    });
    if (res.didError || !res.data) {
      console.error('GetUserDetailsByEmail error:', res.errorMessage);
      loaded = true;
      fetchedSuccessfully = true;
      onLoadedCallbacks.forEach(cb => cb());
      onLoadedCallbacks = [];
      return;
    }
    const payload = res.data;
    userRole = payload.Role || payload.RoleName || '';
    userDivision = payload.Division || '';
    const access = payload.SessionAccess || '';
    sessionAccess = access.split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
    loaded = true;
    fetchedSuccessfully = true;
    onLoadedCallbacks.forEach(cb => cb());
    onLoadedCallbacks = [];
  } catch (e) {
    console.error('Failed to fetch user access:', e);
    loaded = true;
    onLoadedCallbacks.forEach(cb => cb());
    onLoadedCallbacks = [];
  }
}

// Map route paths to possible SessionAccess display names from DB
const routeToAccessMap = {
  'dashboard': ['dashboard'],
  '8d-forms': ['8ds', '8d-forms'],
  'create-new': ['create new', 'create-new'],
  'reports': ['reports'],
  'masters/user-master': ['user master', 'masters/user-master', 'masters'],
  'masters/role-master': ['role & authorization master', 'role master', 'masters/role-master', 'masters']
};

export function hasRouteAccess(path) {
  if (!loaded) return false;
  if (sessionAccess.length === 0) return true; // no restrictions configured
  const normalized = path.replace(/^\//, '').toLowerCase();
  const allowedNames = routeToAccessMap[normalized];
  if (allowedNames) {
    return allowedNames.some(name => sessionAccess.includes(name));
  }
  return sessionAccess.some(page => normalized === page || normalized.startsWith(page + '/'));
}

export function getIsSupplier() { return isSupplier; }
export function getSessionAccess() { return sessionAccess; }
export function getUserRole() { return userRole; }
export function getUserDivision() { return userDivision; }
export function resetAccess() { loaded = false; fetchedSuccessfully = false; sessionAccess = []; userRole = ''; userDivision = ''; isSupplier = false; }
